module.exports = __webpack_public_path__ + "static/img/10a1f2edf28b56399b72b4eef8111920.e318d34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10a1f2edf28b56399b72b4eef8111920.png
// module id = jL6o
// module chunks = 73